import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { appsGetQueryKey } from '../apps.api';
import { TargetModel } from '../types';

import {
  CreateTargetParams,
  DeleteTargetParams,
  UpdateTargetParams,
  useTargetsService,
} from './targets.service';

export const useCreateTarget = () => {
  const TargetsService = useTargetsService();
  const queryClient = useQueryClient();

  return useMutation<TargetModel, AxiosError, CreateTargetParams>({
    mutationFn: (params: CreateTargetParams) => TargetsService.createTarget(params),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [appsGetQueryKey] }),
  });
};

export const useUpdateTarget = () => {
  const targetsService = useTargetsService();
  const queryClient = useQueryClient();

  return useMutation<TargetModel, AxiosError, UpdateTargetParams>({
    mutationFn: (params: UpdateTargetParams) => targetsService.updateTarget(params),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: [appsGetQueryKey] });
    },
  });
};

export const useDeleteTarget = () => {
  const targetsService = useTargetsService();
  const queryClient = useQueryClient();

  return useMutation<TargetModel, AxiosError, DeleteTargetParams>({
    mutationFn: (params: DeleteTargetParams) => targetsService.deleteTarget(params),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: [appsGetQueryKey] });
    },
  });
};
